import { format } from "date-fns"
import i18next from "i18next"

export const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
]

export const filters = [
  {
    name: "status",
    type: "select",
    get options() {
      return [
        { label: i18next.t("All"), value: 2 },
        { label: i18next.t("Active"), value: 1 },
        { label: i18next.t("Deactive"), value: 0 },
      ]
    },
    get placeholder() {
      return i18next.t("Status")
    },
  },
  {
    name: "sortOrder",
    type: "select",
    hidePlaceholder: true,
    get options() {
      return [
        { label: i18next.t("Ascending"), value: 1 },
        { label: i18next.t("Descending"), value: 2 },
      ]
    },
    get placeholder() {
      return i18next.t("Sort Order")
    },
  },
]

export const pageSizes = [10, 20, 30, 40, 50]

export const commonItemPerPage = 10

export const permissionsList = [
  {
    id: 1,
    title: "Dashboard",
    titleAr: "Ù„ÙˆØ­Ø© Ø§Ù„Ù‚ÙŠØ§Ø¯Ø©",
    permissions: [
      {
        id: "dashboard_5",
        value: "view",
        label: "Gift Card",
        labelAr: "Ø¨Ø·Ø§Ù‚Ø© Ø§Ù„Ù‡Ø¯ÙŠØ©",
        isEnabled: false,
      },
      {
        id: "dashboard_1",
        value: "view",
        label: "Sales",
        labelAr: "Ù…Ø¨ÙŠØ¹Ø§Øª",
        isEnabled: false,
      },
      {
        id: "dashboard_2",
        value: "view",
        label: "Branches",
        labelAr: "Ø§Ù„ÙØ±ÙˆØ¹",
        isEnabled: false,
      },
      {
        id: "dashboard_3",
        value: "view",
        label: "Bookings",
        labelAr: "Ø§Ù„Ø­Ø¬ÙˆØ²Ø§Øª",
        isEnabled: false,
      },
      {
        id: "dashboard_4",
        value: "view",
        label: "Ratings",
        labelAr: "Ø§Ù„Ø­Ø¬ÙˆØ²Ø§Øª",
        isEnabled: false,
      },
      {
        id: "dashboard_6",
        value: "view",
        label: "E-Store",
        labelAr: "Ù„ÙˆØ­Ø© Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø§Ù„Ù…ØªØ¬Ø± Ø§Ù„Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ",
        isEnabled: false,
      },
      {
        id: "dashboard_7",
        value: "view",
        label: "Marketing",
        labelAr: "Ù„ÙˆØ­Ø© Ø§Ù„Ù‚ÙŠØ§Ø¯Ø© Ø§Ù„ØªØ³ÙˆÙŠÙ‚ÙŠØ©",
        isEnabled: false,
      },
      {
        id: "dashboard_8",
        value: "view",
        label: "Wallet",
        labelAr: "Ù…Ø­ÙØ¸Ø©",
        isEnabled: false,
      },
      {
        id: "dashboard_9",
        value: "view",
        label: "Loyalty Points",
        labelAr: "Ù†Ù‚Ø§Ø· Ø§Ù„ÙˆÙ„Ø§Ø¡",
        isEnabled: false,
      },
    ],
  },
  {
    id: 2,
    title: "Banners",
    titleAr: "Ù„Ø§ÙØªØ§Øª",
    permissions: [
      {
        id: "inAppContent_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "inAppContent_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "inAppContent_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "inAppContent_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 3,
    title: "Roles",
    titleAr: "Ø§Ù„Ø£Ø¯ÙˆØ§Ø±",
    permissions: [
      {
        id: "roles_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "roles_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "roles_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "roles_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 4,
    title: "Menus",
    titleAr: "Ø§Ù„Ù‚ÙˆØ§Ø¦Ù…",
    permissions: [
      {
        id: "menus_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "menu_full_access_view",
            value: "Full Access",
            label: "Full Access",
            labelAr: "Ø§Ù„ÙˆØµÙˆÙ„ Ø§Ù„ÙƒØ§Ù…Ù„",
            isEnabled: true,
          },
          {
            id: "item_access_view",
            value: "Item Access",
            label: "Item Access",
            labelAr: "Ø§Ù„ÙˆØµÙˆÙ„ Ø¥Ù„Ù‰ Ø§Ù„Ø¹Ù†Ø§ØµØ±",
            isEnabled: true,
          },
          {
            id: "modifier_access_view",
            value: "Modifier Access",
            label: "Modifier Access",
            labelAr: "Ø§Ù„ÙˆØµÙˆÙ„ Ø¥Ù„Ù‰ Ø§Ù„Ø¹Ù†Ø§ØµØ±",
            isEnabled: false,
          },
          {
            id: "combo_access_view",
            value: "Combo Access",
            label: "Combo / Item Groups Access",
            labelAr: "Ø§Ù„ÙˆØµÙˆÙ„ Ø¥Ù„Ù‰ Ø§Ù„ÙƒÙˆÙ…Ø¨Ùˆ ÙˆÙ…Ø¬Ù…ÙˆØ¹Ø§Øª Ø§Ù„Ø¹Ù†Ø§ØµØ±",
            isEnabled: false,
          },
        ],
      },
      {
        id: "menus_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
        subPermissions: [
          {
            id: "link_menu_with_pos",
            value: "update",
            label: "Link menu with POS",
            labelAr: "Ø±Ø¨Ø· Ø§Ù„Ù‚Ø§Ø¦Ù…Ø© Ù…Ø¹ Ù†Ù‚Ø§Ø· Ø§Ù„Ø¨ÙŠØ¹",
            isEnabled: false,
          },
        ],
      },
      {
        id: "menus_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
        subPermissions: [
          {
            id: "link_menu_with_pos",
            value: "update",
            label: "Link menu with POS",
            labelAr: "Ø±Ø¨Ø· Ø§Ù„Ù‚Ø§Ø¦Ù…Ø© Ù…Ø¹ Ù†Ù‚Ø§Ø· Ø§Ù„Ø¨ÙŠØ¹",
            isEnabled: false,
          },
          {
            id: "menu_full_access_update",
            value: "Full Access",
            label: "Full Access",
            labelAr: "Ø§Ù„ÙˆØµÙˆÙ„ Ø§Ù„ÙƒØ§Ù…Ù„",
            isEnabled: true,
          },
          {
            id: "enable_out_of_stock",
            value: "Mark As Out of Stock",
            label: "Mark As Out of Stock",
            labelAr: "ØªÙ…ÙƒÙŠÙ† Ù†ÙØ§Ø¯ Ø§Ù„Ù…Ø®Ø²ÙˆÙ†",
            isEnabled: true,
          },
          {
            id: "enable_disable_item",
            value: "Enabled/Disabled Item",
            label: "Enabled/Disabled Item",
            labelAr: "Ø§Ù„Ø¹Ù†ØµØ± Ø§Ù„Ù…Ù…ÙƒÙ‘Ù†/Ø§Ù„Ù…Ø¹Ø·Ù„",
            isEnabled: true,
          },
          {
            id: "enable_out_of_stock_modifier",
            value: "Mark As Out Of Stock Modifier",
            label: "Mark As Out Of Stock Modifier",
            labelAr: "ØªØ­Ø¯ÙŠØ¯ ÙƒÙ…Ø¹Ø¯Ù„ ØºÙŠØ± Ù…ØªÙˆÙØ± ÙÙŠ Ø§Ù„Ù…Ø®Ø²ÙˆÙ†",
            isEnabled: true,
          },
          {
            id: "clear_menu_cache",
            value: "Clear Menu Cache",
            label: "Clear Menu Cache",
            labelAr: "Ù…Ø³Ø­ Ø°Ø§ÙƒØ±Ø© ØªØ®Ø²ÙŠÙ† Ø§Ù„Ù‚Ø§Ø¦Ù…Ø©",
            isEnabled: false,
          },
        ],
      },

      {
        id: "menus_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
      {
        id: "item_tag_1",
        value: "item_tags_view",
        label: "Item Tags View",
        labelAr: "Ø¹Ø±Ø¶ ÙˆØ³ÙˆÙ… Ø§Ù„Ù…Ù†ØªØ¬Ø§Øª",
        isEnabled: false,
      },
      {
        id: "item_tag_2",
        value: "item_tags_add",
        label: "Item Tags Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ© ÙˆØ³ÙˆÙ… Ø§Ù„Ù…Ù†ØªØ¬Ø§Øª",
        isEnabled: false,
      },
      {
        id: "item_tag_3",
        value: "item_tags_update",
        label: "Item Tags Update",
        labelAr: "ØªØ­Ø¯ÙŠØ« ÙˆØ³ÙˆÙ… Ø§Ù„Ù…Ù†ØªØ¬Ø§Øª",
        isEnabled: false,
      },
      {
        id: "item_tag_4",
        value: "item_tags_delete",
        label: "Item Tags Delete",
        labelAr: "Ø­Ø°Ù ÙˆØ³ÙˆÙ… Ø§Ù„Ù…Ù†ØªØ¬Ø§Øª",
        isEnabled: false,
      },
      {
        id: "web_item_preview_1",
        value: "web_item_preview_view",
        label: "Web Item Preview",
        labelAr: "معاينة عنصر الويب",
        isEnabled: false,
      },
      {
        id: "mobile_item_preview_1",
        value: "mobile_item_preview_view",
        label: "Mobile Item Preview",
        labelAr: "معاينة عنصر الجوال",
        isEnabled: false,
      },
    ],
  },
  {
    id: 5,
    title: "Branch/Locations",
    titleAr: "Ø§Ù„ÙØ±ÙˆØ¹/Ø§Ù„Ù…ÙˆØ§Ù‚Ø¹",
    permissions: [
      {
        id: "branchLocations_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "branchLocations_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "branchLocations_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
        subPermissions: [
          {
            id: "edit_opening_hours",
            value: "Opening hours editing",
            label: "Opening hours editing",
            labelAr: "ØªØ­Ø±ÙŠØ± Ø³Ø§Ø¹Ø§Øª Ø§Ù„Ø¹Ù…Ù„",
            isEnabled: true,
          },
          {
            id: "edit_branch_status",
            value: "Branch active/deactive settings",
            label: "Branch active/deactive settings",
            labelAr: "ÙØ±Ø¹ Ø§Ù„Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø§Ù„Ù†Ø´Ø·Ø© / ØºÙŠØ± Ø§Ù„Ù†Ø´Ø·Ø©",
            isEnabled: true,
          },
          {
            id: "edit_branch_name_settings",
            value: "Branch name settings",
            label: "Branch name settings",
            labelAr: "Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø§Ø³Ù… Ø§Ù„ÙØ±Ø¹",
            isEnabled: true,
          },
          {
            id: "copy_branch_settings",
            value: "Copy branch settings",
            label: "Copy branch settings",
            labelAr: "Ù†Ø³Ø® Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø§Ù„ÙØ±Ø¹",
            isEnabled: true,
          },
          {
            id: "clone_branch",
            value: "Clone Branch",
            label: "Clone Branch",
            labelAr: "ÙØ±Ø¹ Ø§Ù„Ø§Ø³ØªÙ†Ø³Ø§Ø®",
            isEnabled: true,
          },
          {
            id: "enable_pickup",
            value: "Enable Pickup",
            label: "Enable Pickup",
            labelAr: "ØªÙØ¹ÙŠÙ„ Ø§Ù„Ø§Ø³ØªÙ„Ø§Ù…",
            isEnabled: true,
          },
          {
            id: "enable_delivery",
            value: "Enable Delivery",
            label: "Enable Delivery",
            labelAr: "ØªÙØ¹ÙŠÙ„ Ø§Ù„ØªÙˆØµÙŠÙ„",
            isEnabled: true,
          },
          {
            id: "enable_curbside",
            value: "Enable Curbside",
            label: "Enable Curbside",
            labelAr: "ØªÙØ¹ÙŠÙ„ Ø§Ù„Ø§Ø³ØªÙ„Ø§Ù… Ù…Ù† Ø§Ù„Ø±ØµÙŠÙ",
            isEnabled: true,
          },
          {
            id: "enable_drive_thru",
            value: "Enable Drive Thru",
            label: "Enable Drive Thru",
            labelAr: "ØªÙØ¹ÙŠÙ„ Ø§Ù„Ø·Ù„Ø¨ Ù…Ù† Ø§Ù„Ø³ÙŠØ§Ø±Ø©",
            isEnabled: true,
          },
          {
            id: "enable_dine_in",
            value: "Enable Dine In",
            label: "Enable Dine In",
            labelAr: "ØªÙØ¹ÙŠÙ„ ØªÙ†Ø§ÙˆÙ„ Ø§Ù„Ø·Ø¹Ø§Ù… ÙÙŠ Ø§Ù„Ù…Ø·Ø¹Ù…",
            isEnabled: true,
          },
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Users",
    titleAr: "Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙˆÙ†",
    permissions: [
      {
        id: "usersPermission_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "usersPermission_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "usersPermission_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "usersPermission_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 7,
    title: "Customers",
    titleAr: "Ø¹Ù…Ù„Ø§Ø¡",
    permissions: [
      {
        id: "customersPermission_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "view_device_information",
            value: "Device Information",
            label: "Device Information",
            labelAr: "Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø§Ù„Ø¬Ù‡Ø§Ø²",
            isEnabled: true,
          },
          {
            id: "view_orders",
            value: "Orders",
            label: "Orders",
            labelAr: "Ø·Ù„Ø¨Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_loyalty_points",
            value: "Loyalty Points",
            label: "Loyalty Points",
            labelAr: "Ù†Ù‚Ø§Ø· Ø§Ù„ÙˆÙ„Ø§Ø¡",
            isEnabled: true,
          },
          {
            id: "view_payment_history",
            value: "Payment History",
            label: "Payment History",
            labelAr: "Ø·Ù„Ø¨Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_wallet_history",
            value: "Wallet History",
            label: "Wallet History",
            labelAr: "ØªØ§Ø±ÙŠØ® Ø§Ù„Ù…Ø­ÙØ¸Ø©",
            isEnabled: true,
          },
          {
            id: "view_gift_card_usage",
            value: "Gift Card Usage",
            label: "Gift Card Usage",
            labelAr: "Ø§Ø³ØªØ®Ø¯Ø§Ù… Ø¨Ø·Ø§Ù‚Ø© Ø§Ù„Ù‡Ø¯ÙŠØ©",
            isEnabled: false,
          },
        ],
      },
      {
        id: "customersPermission_2",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "customersPermission_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
      {
        id: "customersPermission_5",
        value: "restore",
        label: "View deleted customers and Restore",
        labelAr: "Ø¹Ø±Ø¶ Ø§Ù„Ø¹Ù…Ù„Ø§Ø¡ Ø§Ù„Ù…Ø­Ø°ÙˆÙÙŠÙ† ÙˆØ§Ø³ØªØ¹Ø§Ø¯ØªÙ‡Ù…",
        isEnabled: false,
      },
      {
        id: "customersPermission_6",
        value: "block",
        label: "Block/Unblock",
        labelAr: "حظر/إلغاء الحظر",
        isEnabled: false,
      },
    ],
  },
  // {
  //   id: 8,
  //   title: "Feedback",
  //   permissions: [
  //     {
  //       id: "feedback_1",
  //       value: "view",
  //       label: "View",
  //       labelAr: "Ø¹Ø±Ø¶",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "feedback_2",
  //       value: "viewRatings",
  //       label: "View Ratings",
  //       labelAr: "Ø¹Ø±Ø¶ Ø§Ù„ØªÙ‚ÙŠÙŠÙ…Ø§Øª",
  //       isEnabled: false,
  //     },
  //   ],
  // },
  {
    id: 9,
    title: "Orders",
    titleAr: "Ø·Ù„Ø¨Ø§Øª",
    permissions: [
      {
        id: "order_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "city_zones_map",
            value: "map",
            label: "Map",
            labelAr: "خريطة",
            isEnabled: false,
          },
        ],
      },
      {
        id: "order_2",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
        subPermissions: [
          {
            id: "update_delivery_date",
            value: "update",
            label: "Update Delivery Date",
            labelAr: "ØªØ­Ø¯ÙŠØ« ØªØ§Ø±ÙŠØ® Ø§Ù„ØªÙˆØµÙŠÙ„",
            isEnabled: false,
          },
        ],
      },
      {
        id: "order_3",
        value: "assign",
        label: "Assign",
        labelAr: "ØªØ¹ÙŠÙŠÙ†",
        isEnabled: true,
        subPermissions: [
          {
            id: "assign_orders_to_rider",
            value: "Assign to Rider",
            label: "Assign Orders to Rider",
            labelAr: "ØªØ¹ÙŠÙŠÙ† Ø§Ù„Ø·Ù„Ø¨Ø§Øª Ù„Ù„Ø³Ø§Ø¦Ù‚",
            isEnabled: true,
          },
          {
            id: "assign_orders_to_branch",
            value: "Assign to Branch",
            label: "Assign Orders to Branch",
            labelAr: "ØªØ¹ÙŠÙŠÙ† Ø§Ù„Ø·Ù„Ø¨Ø§Øª Ù„Ù„ÙØ±Ø¹",
            isEnabled: true,
          },
        ],
      },
      {
        id: "order_4",
        value: "export",
        label: "Export",
        labelAr: "ØªØµØ¯ÙŠØ±",
        isEnabled: false,
      },
    ],
  },
  // {
  //   id: 10,
  //   title: "Curbside Pickup",
  //   permissions: [
  //     {
  //       id: "curbside_1",
  //       value: "view",
  //       label: "View",
  //       labelAr: "Ø¹Ø±Ø¶",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "curbside_2",
  //       value: "update",
  //       label: "Update",
  //       labelAr: "ØªØ­Ø¯ÙŠØ«",
  //       isEnabled: false,
  //     },
  //   ],
  // },
  {
    id: 11,
    title: "Countries",
    titleAr: "Ø¨Ù„Ø¯Ø§Ù†",
    permissions: [
      {
        id: "country_1",
        value: "view",
        label: "View",
        labelAr: "Ù…Ù†Ø¸Ø±",
        isEnabled: false,
      },
      {
        id: "country_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "country_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "country_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
      {
        id: "country_5",
        value: "edit",
        label: "Edit",
        labelAr: "ØªØ¹Ø¯ÙŠÙ„",
        isEnabled: false,
      },
    ],
  },
  // {
  //   id: 12,
  //   title: "Tax (VAT)",
  //   titleAr: "Ø¶Ø±ÙŠØ¨Ø© Ø§Ù„Ù‚ÙŠÙ…Ø© Ø§Ù„Ù…Ø¶Ø§ÙØ©)",
  //   permissions: [
  //     {
  //       id: "tax_1",
  //       value: "view",
  //       label: "View",
  //       labelAr: "Ù…Ù†Ø¸Ø±",
  //       isEnabled: false,
  //     },
  //     {
  //       id: "tax_2",
  //       value: "update",
  //       label: "Update",
  //       labelAr: "ØªØ­Ø¯ÙŠØ«",
  //       isEnabled: false,
  //     },
  //   ],
  // },
  {
    id: 13,
    title: "API Logs",
    titleAr: "Ø³Ø¬Ù„Ø§Øª API",
    permissions: [
      {
        id: "api_logs_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
    ],
  },
  {
    id: 14,
    title: "Discounts/Coupons",
    titleAr: "Ø§Ù„Ø®ØµÙˆÙ…Ø§Øª/Ø§Ù„ÙƒÙˆØ¨ÙˆÙ†Ø§Øª",
    permissions: [
      {
        id: "promotion_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "promotion_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
        subPermissions: [
          {
            id: "link_discount_with_pos",
            value: "update",
            label: "Link discount with POS",
            labelAr: "Ø±Ø¨Ø· Ø§Ù„Ø®ØµÙ… Ù…Ø¹ Ù†Ù‚Ø§Ø· Ø§Ù„Ø¨ÙŠØ¹",
            isEnabled: false,
          },
        ],
      },
      {
        id: "promotion_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
        subPermissions: [
          {
            id: "link_discount_with_pos",
            value: "update",
            label: "Link discount with POS",
            labelAr: "Ø±Ø¨Ø· Ø§Ù„Ø®ØµÙ… Ù…Ø¹ Ù†Ù‚Ø§Ø· Ø§Ù„Ø¨ÙŠØ¹",
            isEnabled: false,
          },
        ],
      },

      {
        id: "promotion_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 15,
    title: "Notifications",
    titleAr: "Ø¥Ø´Ø¹Ø§Ø±Ø§Øª",
    permissions: [
      {
        id: "notification_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "customize_notifications",
            value: "view",
            label: "Customize Notifications",
            labelAr: "ØªØ®ØµÙŠØµ Ø§Ù„Ø¥Ø´Ø¹Ø§Ø±Ø§Øª",
            isEnabled: false,
          },
          {
            id: "customize_notifications_ios",
            value: "view",
            label: "Customize Notifications (iOS)",
            labelAr: "ØªØ®ØµÙŠØµ Ø§Ù„Ø¥Ø´Ø¹Ø§Ø±Ø§Øª (iOS)",
            isEnabled: false,
          },
        ],
      },

      {
        id: "notification_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 16,
    title: "Reports",
    titleAr: "Ø§Ù„ØªÙ‚Ø§Ø±ÙŠØ±",
    permissions: [
      {
        id: "report_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "view_sales_reports",
            value: "view",
            label: "Sales Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ø§Ù„Ù…Ø¨ÙŠØ¹Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_wallet_reports",
            value: "view",
            label: "Wallet Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ø§Ù„Ù…Ø­ÙØ¸Ø©",
            isEnabled: true,
          },
          {
            id: "view_wallet_transfer_reports",
            value: "view",
            label: "Wallet Transfer Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± ØªØ­ÙˆÙŠÙ„ Ø§Ù„Ù…Ø­ÙØ¸Ø©",
            isEnabled: true,
          },
          {
            id: "view_wallet_purchase_reports",
            value: "view",
            label: "Wallet Purchase Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ù…Ø´ØªØ±ÙŠØ§Øª Ø§Ù„Ù…Ø­ÙØ¸Ø©",
            isEnabled: true,
          },
          {
            id: "view_premium_gift_card_reports",
            value: "view",
            label: "Premium Gift Card Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ø¨Ø·Ø§Ù‚Ø§Øª Ø§Ù„Ù‡Ø¯Ø§ÙŠØ§ Ø§Ù„Ù…Ù…ÙŠØ²Ø©",
            isEnabled: true,
          },
          {
            id: "view_payments_reports",
            value: "view",
            label: "Payments Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_business_tax_reports",
            value: "view",
            label: "Business Tax Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ø¶Ø±ÙŠØ¨Ø© Ø§Ù„Ø£Ø¹Ù…Ø§Ù„",
            isEnabled: true,
          },
          {
            id: "view_loyalty_points_reports",
            value: "view",
            label: "Loyalty Points Reports",
            labelAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ù†Ù‚Ø§Ø· Ø§Ù„ÙˆÙ„Ø§Ø¡",
            isEnabled: true,
          },
        ],
      },
    ],
  },
  {
    id: 17,
    title: "Customer Support",
    titleAr: "Ø¯Ø¹Ù… Ø§Ù„Ø¹Ù…Ù„Ø§Ø¡",
    permissions: [
      {
        id: "customer_support_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "customer_support_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "customer_support_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "customer_support_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 18,
    title: "FAQ",
    titleAr: "Ø§Ù„ØªØ¹Ù„ÙŠÙ…Ø§Øª",
    permissions: [
      {
        id: "faq_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "faq_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "faq_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "faq_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 19,
    title: "Referral Settings",
    titleAr: "Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø§Ù„Ø¥Ø­Ø§Ù„Ø©",
    permissions: [
      {
        id: "referral_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "referral_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 20,
    title: "Loyalty Settings",
    titleAr: "Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø§Ù„ÙˆÙ„Ø§Ø¡",
    permissions: [
      {
        id: "loyalty_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "loyalty_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 21,
    title: "Bookings",
    titleAr: "Ø§Ù„Ø­Ø¬ÙˆØ²Ø§Øª",
    permissions: [
      {
        id: "booking_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "booking_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 22,
    title: "QR Code",
    titleAr: "Ø±Ù…Ø² Ø§Ù„Ø§Ø³ØªØ¬Ø§Ø¨Ø© Ø§Ù„Ø³Ø±ÙŠØ¹Ø©",
    permissions: [
      {
        id: "qr_code_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "generate_order_qr",
            value: "view",
            label: "Generate Order QR",
            labelAr: "Ø¥Ù†Ø´Ø§Ø¡ Ø±Ù…Ø² QR Ù„Ù„Ø·Ù„Ø¨",
            isEnabled: false,
          },
        ],
      },
      {
        id: "qr_code_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
        subPermissions: [
          {
            id: "generate_order_qr",
            value: "update",
            label: "Generate Order QR",
            labelAr: "Ø¥Ù†Ø´Ø§Ø¡ Ø±Ù…Ø² QR Ù„Ù„Ø·Ù„Ø¨",
            isEnabled: false,
          },
        ],
      },
    ],
  },
  {
    id: 23,
    title: "Ingredients",
    titleAr: "Ù…ÙƒÙˆÙ†Ø§Øª",
    permissions: [
      {
        id: "ingredient_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "ingredient_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "ingredient_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "ingredient_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 24,
    title: "Allergens",
    titleAr: "Ø§Ù„Ù…ÙˆØ§Ø¯ Ø§Ù„Ù…Ø³Ø¨Ø¨Ø© Ù„Ù„Ø­Ø³Ø§Ø³ÙŠØ©",
    permissions: [
      {
        id: "allergen_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "allergen_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "allergen_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "allergen_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 25,
    title: "Regions",
    titleAr: "Ø§Ù„Ù…Ù†Ø§Ø·Ù‚",
    permissions: [
      {
        id: "region_1",
        value: "view",
        label: "View",
        labelAr: "Ù…Ù†Ø¸Ø±",
        isEnabled: false,
      },
      {
        id: "region_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "region_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "region_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 26,
    title: "Cities",
    titleAr: "Ù…Ø¯Ù†",
    permissions: [
      {
        id: "city_1",
        value: "view",
        label: "View",
        labelAr: "Ù…Ù†Ø¸Ø±",
        isEnabled: false,
        subPermissions: [
          {
            id: "city_map",
            value: "map",
            label: "Map",
            labelAr: "خريطة",
            isEnabled: false,
          },
        ],
      },
      {
        id: "city_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "city_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "city_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 43,
    title: "Zones",
    titleAr: "Ø§Ù„Ù…Ù†Ø§Ø·Ù‚",
    permissions: [
      {
        id: "zone_1",
        value: "view",
        label: "View",
        labelAr: "Ù…Ù†Ø¸Ø±",
        isEnabled: false,
      },
      {
        id: "zone_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "zone_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "zone_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 27,
    title: "Rating & Feedback",
    titleAr: "Ø§Ù„ØªÙ‚ÙŠÙŠÙ… ÙˆØ±Ø¯ÙˆØ¯ Ø§Ù„ÙØ¹Ù„",
    permissions: [
      {
        id: "rating_1",
        value: "view",
        label: "View",
        labelAr: "Ù…Ù†Ø¸Ø±",
        isEnabled: false,
      },
      {
        id: "rating_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "rating_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "rating_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 28,
    title: "POS(API Key)",
    titleAr: "Ù†Ù‚Ø§Ø· Ø§Ù„Ø¨ÙŠØ¹ (Ù…ÙØªØ§Ø­ API)",
    permissions: [
      {
        id: "api_key_1",
        value: "view",
        label: "View",
        labelAr: "Ù…Ù†Ø¸Ø±",
        isEnabled: false,
      },
      {
        id: "api_key_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 29,
    title: "POS(Branch Sync)",
    titleAr: "Ù†Ù‚Ø§Ø· Ø§Ù„Ø¨ÙŠØ¹ (Ù…Ø²Ø§Ù…Ù†Ø© Ø§Ù„ÙØ±ÙˆØ¹)",
    permissions: [
      {
        id: "branch_sync_1",
        value: "view",
        label: "View",
        labelAr: "Ù…Ù†Ø¸Ø±",
        isEnabled: false,
      },
      {
        id: "branch_sync_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 30,
    title: "POS(Menu Sync)",
    titleAr: "Ù†Ù‚Ø§Ø· Ø§Ù„Ø¨ÙŠØ¹ (Ù…Ø²Ø§Ù…Ù†Ø© Ø§Ù„Ù‚Ø§Ø¦Ù…Ø©)",
    permissions: [
      {
        id: "menu_sync_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 31,
    title: "Add Emails",
    titleAr: "Ø¥Ø¶Ø§ÙØ© Ø±Ø³Ø§Ø¦Ù„ Ø§Ù„Ø¨Ø±ÙŠØ¯ Ø§Ù„Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ",
    permissions: [
      {
        id: "add_emails_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "add_emails_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 32,
    title: "App Settings",
    titleAr: "Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø§Ù„ØªØ·Ø¨ÙŠÙ‚",
    permissions: [
      {
        id: "app_settings_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "enable_erp_integration",
            value: "view",
            label: "ERP Integration",
            labelAr: "ØªÙƒØ§Ù…Ù„ ERP",
            isEnabled: false,
          },
        ],
      },
      {
        id: "app_settings_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
        subPermissions: [
          {
            id: "enable_erp_integration",
            value: "update",
            label: "ERP Integration",
            labelAr: "ØªÙƒØ§Ù…Ù„ ERP",
            isEnabled: false,
          },
        ],
      },
    ],
  },
  {
    id: 33,
    title: "Terms And Condtions",
    titleAr: "Ø§Ù„Ø´Ø±ÙˆØ· ÙˆØ§Ù„Ø£Ø­ÙƒØ§Ù…",
    permissions: [
      {
        id: "term_condition_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "term_condition_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 34,
    title: "Privacy Policy",
    titleAr: "Ø³ÙŠØ§Ø³Ø© Ø§Ù„Ø®ØµÙˆØµÙŠØ©",
    permissions: [
      {
        id: "privacy_policy_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "privacy_policy_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 35,
    title: "Vehicles",
    titleAr: "Ø§Ù„Ù…Ø±ÙƒØ¨Ø§Øª",
    permissions: [
      {
        id: "vehicle_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "vehicle_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "vehicle_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "vehicle_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 36,
    title: "User Activity",
    titleAr: "Ù†Ø´Ø§Ø· Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…",
    permissions: [
      {
        id: "user_activity_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
    ],
  },
  {
    id: 37,
    title: "Gift Card",
    titleAr: "Ø¨Ø·Ø§Ù‚Ø© Ù‡Ø¯ÙŠØ©",
    permissions: [
      {
        id: "gift_card_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "gift_card_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "gift_card_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },

      {
        id: "gift_card_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 38,
    title: "Gift Card Usage",
    titleAr: "Ø§Ø³ØªØ®Ø¯Ø§Ù… Ø¨Ø·Ø§Ù‚Ø© Ø§Ù„Ù‡Ø¯Ø§ÙŠØ§",
    permissions: [
      {
        id: "gift_card_usage_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
    ],
  },
  {
    id: 39,
    title: "Gift Card Deep Link",
    titleAr: "Ø±Ø§Ø¨Ø· Ø¨Ø·Ø§Ù‚Ø© Ø§Ù„Ù‡Ø¯ÙŠØ© Ø§Ù„Ø¹Ù…ÙŠÙ‚",
    permissions: [
      {
        id: "dynamic_link_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "dynamic_link_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
    ],
  },
  {
    id: 40,
    title: "Gift Card Settings",
    titleAr: "Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø¨Ø·Ø§Ù‚Ø© Ø§Ù„Ù‡Ø¯ÙŠØ©",
    permissions: [
      {
        id: "gift_card_settings_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "gift_card_settings_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 41,
    title: "Static Maintenance",
    titleAr: "Ø§Ù„ØµÙŠØ§Ù†Ø© Ø§Ù„Ø¯ÙˆØ±ÙŠØ©",
    permissions: [
      {
        id: "static_maintenance_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "static_maintenance_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "static_maintenance_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "static_maintenance_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 44,
    title: "Brand",
    titleAr: "Ø¹Ù„Ø§Ù…Ø© ØªØ¬Ø§Ø±ÙŠØ©",
    permissions: [
      {
        id: "FNB",
        value: "FNB",
        label: "FNB",
        labelAr: "FNB",
        isEnabled: false,
      },
      {
        id: "B2C",
        value: "B2C",
        label: "B2C",
        labelAr: "B2C",
        isEnabled: false,
      },
    ],
  },
  {
    id: 46,
    title: "Wallet Coupon",
    titleAr: "ÙƒÙˆØ¨ÙˆÙ† Ø§Ù„Ù…Ø­ÙØ¸Ø©",
    permissions: [
      {
        id: "coupon_redeem_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "coupon_redeem_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "coupon_redeem_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "coupon_redeem_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 45,
    title: "E-Store Reports",
    titleAr: "ØªÙ‚Ø§Ø±ÙŠØ± Ø§Ù„Ù…ØªØ¬Ø± Ø§Ù„Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ",
    permissions: [
      {
        id: "estore_report_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "view_sales_by_product",
            value: "Sales Report By Product",
            label: "Sales Report By Product",
            labelAr: "ØªÙ‚Ø±ÙŠØ± Ø§Ù„Ù…Ø¨ÙŠØ¹Ø§Øª Ø­Ø³Ø¨ Ø§Ù„Ù…Ù†ØªØ¬",
            isEnabled: true,
          },
          {
            id: "view_summary_sales",
            value: "Summary Sales Report",
            label: "Summary Sales Report",
            labelAr: "ØªÙ‚Ø±ÙŠØ± Ø§Ù„Ù…Ø¨ÙŠØ¹Ø§Øª Ø§Ù„Ù…ÙˆØ¬Ø²",
            isEnabled: true,
          },
          {
            id: "view_sales_orders_details",
            value: "Sales Order Details",
            label: "Sales Order Details",
            labelAr: "ØªÙØ§ØµÙŠÙ„ Ø·Ù„Ø¨ Ø§Ù„Ù…Ø¨ÙŠØ¹Ø§Øª",
            isEnabled: true,
          },
        ],
      },
    ],
  },
  {
    id: 47,
    title: "Delivery Partners",
    titleAr: "Ø´Ø±ÙƒØ§Ø¡ Ø§Ù„ØªÙˆØµÙŠÙ„",
    permissions: [
      {
        id: "delivery_partners_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
        subPermissions: [
          {
            id: "view_rider_overview",
            value: "Overview",
            label: "Overview",
            labelAr: "Ù†Ø¸Ø±Ø© Ø¹Ø§Ù…Ø©",
            isEnabled: true,
          },
          {
            id: "view_rider_status_history",
            value: "Status History",
            label: "Status History",
            labelAr: "Ø³Ø¬Ù„ Ø§Ù„Ø­Ø§Ù„Ø©",
            isEnabled: true,
          },
          {
            id: "view_rider_documents",
            value: "Documents",
            label: "Documents",
            labelAr: "Ø§Ù„Ù…Ø³ØªÙ†Ø¯Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_rider_orders",
            value: "Orders",
            label: "Orders",
            labelAr: "Ø§Ù„Ø·Ù„Ø¨Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_rider_earnings",
            value: "Earnings",
            label: "Earnings",
            labelAr: "Ø§Ù„Ø£Ø±Ø¨Ø§Ø­",
            isEnabled: true,
          },
          {
            id: "view_rider_payments",
            value: "Payments",
            label: "Payments",
            labelAr: "Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_rider_ratings",
            value: "Ratings",
            label: "Ratings",
            labelAr: "Ø§Ù„ØªÙ‚ÙŠÙŠÙ…Ø§Øª",
            isEnabled: true,
          },
          {
            id: "view_rider_location",
            value: "Location",
            label: "Location",
            labelAr: "Ø§Ù„Ù…ÙˆÙ‚Ø¹",
            isEnabled: true,
          },
        ],
      },
      {
        id: "delivery_partners_2",
        value: "add_update",
        label: "Add/Update",
        labelAr: "Ø¥Ø¶Ø§ÙØ©/ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "delivery_partners_3",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
      {
        id: "delivery_partners_4",
        value: "documents",
        label: "Manage Documents",
        labelAr: "Ø¥Ø¯Ø§Ø±Ø© Ø§Ù„Ù…Ø³ØªÙ†Ø¯Ø§Øª",
        isEnabled: false,
      },
      {
        id: "delivery_partners_5",
        value: "location",
        label: "Manage Location",
        labelAr: "Ø¥Ø¯Ø§Ø±Ø© Ø§Ù„Ù…ÙˆÙ‚Ø¹",
        isEnabled: false,
      },
      {
        id: "delivery_partners_6",
        value: "earnings",
        label: "Manage Earnings",
        labelAr: "Ø¥Ø¯Ø§Ø±Ø© Ø§Ù„Ø£Ø±Ø¨Ø§Ø­",
        isEnabled: false,
      },
      {
        id: "delivery_partners_7",
        value: "bank",
        label: "Bank Details",
        labelAr: "ØªÙØ§ØµÙŠÙ„ Ø§Ù„Ø¨Ù†Ùƒ",
        isEnabled: false,
      },
    ],
  },
  {
    id: 48,
    title: "Integrations",
    titleAr: "Ø§Ù„ØªÙƒØ§Ù…Ù„Ø§Øª",
    permissions: [
      {
        id: "tenant_integrations_1",
        value: "view",
        label: "View (list, OTP, credentials)",
        labelAr: "Ø¹Ø±Ø¶ (Ø§Ù„Ù‚Ø§Ø¦Ù…Ø©ØŒ Ø±Ù…Ø² Ø§Ù„ØªØ­Ù‚Ù‚ØŒ Ø§Ù„Ø¨ÙŠØ§Ù†Ø§Øª)",
        isEnabled: false,
      },
      {
        id: "tenant_integrations_2",
        value: "connect",
        label: "Connect / reconnect",
        labelAr: "Ø±Ø¨Ø· / Ø¥Ø¹Ø§Ø¯Ø© Ø§Ù„Ø±Ø¨Ø·",
        isEnabled: false,
      },
      {
        id: "tenant_integrations_3",
        value: "update",
        label: "Edit / update integration (incl. OTP)",
        labelAr: "ØªØ¹Ø¯ÙŠÙ„ / ØªØ­Ø¯ÙŠØ« Ø§Ù„ØªÙƒØ§Ù…Ù„ (ÙŠØ´Ù…Ù„ Ø±Ù…Ø² Ø§Ù„ØªØ­Ù‚Ù‚)",
        isEnabled: false,
      },
      {
        id: "tenant_integrations_4",
        value: "delete",
        label: "Remove integration (incl. OTP)",
        labelAr: "Ø¥Ø²Ø§Ù„Ø© Ø§Ù„ØªÙƒØ§Ù…Ù„",
        isEnabled: false,
      },
      {
        id: "tenant_integrations_5",
        value: "disconnect",
        label: "Disconnect integration (incl. OTP)",
        labelAr: "Ù‚Ø·Ø¹ Ø§ØªØµØ§Ù„ Ø§Ù„ØªÙƒØ§Ù…Ù„ (ÙŠØ´Ù…Ù„ Ø±Ù…Ø² Ø§Ù„ØªØ­Ù‚Ù‚)",
        isEnabled: false,
      },
    ],
  },
  {
    id: 49,
    title: "Offer Banners",
    titleAr: "Ù„Ø§ÙØªØ§Øª Ø§Ù„Ø¹Ø±ÙˆØ¶",
    permissions: [
      {
        id: "offerBanner_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "offerBanner_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "offerBanner_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "offerBanner_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 50,
    title: "Order Cancel Settings",
    titleAr: "Ø¥Ø¹Ø¯Ø§Ø¯Ø§Øª Ø¥Ù„ØºØ§Ø¡ Ø§Ù„Ø·Ù„Ø¨",
    permissions: [
      {
        id: "order_cancel_settings_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "order_cancel_settings_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 51,
    title: "Billing & Subscription",
    titleAr: "Ø§Ù„ÙÙˆØªØ±Ø© ÙˆØ§Ù„Ø§Ø´ØªØ±Ø§Ùƒ",
    permissions: [
      {
        id: "billing_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "billing_2",
        value: "manage",
        label: "Manage subscription",
        labelAr: "Ø¥Ø¯Ø§Ø±Ø© Ø§Ù„Ø§Ø´ØªØ±Ø§Ùƒ",
        isEnabled: false,
      },
      {
        id: "billing_3",
        value: "invoices",
        label: "Invoices",
        labelAr: "Ø§Ù„ÙÙˆØ§ØªÙŠØ±",
        isEnabled: false,
      },
    ],
  },
  {
    id: 52,
    title: "Brand Management",
    titleAr: "Ø¥Ø¯Ø§Ø±Ø© Ø§Ù„Ø¹Ù„Ø§Ù…Ø§Øª Ø§Ù„ØªØ¬Ø§Ø±ÙŠØ©",
    permissions: [
      {
        id: "brands_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
    ],
  },
  {
    id: 53,
    title: "Social Login",
    titleAr: "ØªØ³Ø¬ÙŠÙ„ Ø§Ù„Ø¯Ø®ÙˆÙ„ Ø§Ù„Ø§Ø¬ØªÙ…Ø§Ø¹ÙŠ",
    permissions: [
      {
        id: "social_auth_settings_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "social_auth_settings_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 54,
    title: "Rider FAQ",
    titleAr: "Ø£Ø³Ø¦Ù„Ø© Ø§Ù„Ø³Ø§Ø¦Ù‚ Ø§Ù„Ø´Ø§Ø¦Ø¹Ø©",
    permissions: [
      {
        id: "rider_faq_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "rider_faq_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "rider_faq_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "rider_faq_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 55,
    title: "Rider Terms And Conditions",
    titleAr: "Ø´Ø±ÙˆØ· ÙˆØ£Ø­ÙƒØ§Ù… Ø§Ù„Ø³Ø§Ø¦Ù‚",
    permissions: [
      {
        id: "rider_term_condition_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "rider_term_condition_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 56,
    title: "Rider Privacy Policy",
    titleAr: "Ø³ÙŠØ§Ø³Ø© Ø®ØµÙˆØµÙŠØ© Ø§Ù„Ø³Ø§Ø¦Ù‚",
    permissions: [
      {
        id: "rider_privacy_policy_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "rider_privacy_policy_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 57,
    title: "Website Builder",
    titleAr: "Ù…Ù†Ø´Ø¦ Ø§Ù„Ù…ÙˆÙ‚Ø¹",
    permissions: [
      {
        id: "website_builder_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "website_builder_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
  {
    id: 58,
    title: "Foodics Features",
    titleAr: "ميزات فودكس",
    permissions: [
      {
        id: "foodics_combos_sync_3",
        value: "update",
        label: "Combos Sync",
        labelAr: "مزامنة الكومبو",
        isEnabled: false,
      },
      {
        id: "foodics_discount_link_3",
        value: "update",
        label: "Discount / Coupon Link",
        labelAr: "ربط الخصم / القسيمة",
        isEnabled: false,
      },
      {
        id: "foodics_order_push_3",
        value: "update",
        label: "Order Push",
        labelAr: "إرسال الطلبات",
        isEnabled: false,
      },
      {
        id: "foodics_status_sync_3",
        value: "update",
        label: "Status Sync",
        labelAr: "مزامنة الحالة",
        isEnabled: false,
      },
      {
        id: "foodics_order_calculator_3",
        value: "update",
        label: "Order Calculator",
        labelAr: "حاسبة الطلب",
        isEnabled: false,
      },
      {
        id: "foodics_charges_sync_3",
        value: "update",
        label: "Charges (Delivery / Service Fee)",
        labelAr: "الرسوم (التوصيل / الخدمة)",
        isEnabled: false,
      },
    ],
  },
  {
    id: 59,
    title: "Delivery Settings",
    titleAr: "إعدادات التوصيل",
    permissions: [
      {
        id: "delivery_settings_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "delivery_settings_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
  {
    id: 60,
    title: "Wallet Settings",
    titleAr: "إعدادات المحفظة",
    permissions: [
      {
        id: "wallet_settings_1",
        value: "view",
        label: "View",
        labelAr: "عرض",
        isEnabled: false,
      },
      {
        id: "wallet_settings_3",
        value: "update",
        label: "Update",
        labelAr: "تحديث",
        isEnabled: false,
      },
    ],
  },
]

export const superAdminPermissionsList = [
  {
    id: 101,
    title: "SA Dashboard",
    titleAr: "Ù„ÙˆØ­Ø© ØªØ­ÙƒÙ… Ø§Ù„Ø³ÙˆØ¨Ø± Ø£Ø¯Ù…Ù†",
    permissions: [
      {
        id: "sa_dashboard_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
    ],
  },
  {
    id: 102,
    title: "SA Roles",
    titleAr: "Ø£Ø¯ÙˆØ§Ø± Ø§Ù„Ø³ÙˆØ¨Ø± Ø£Ø¯Ù…Ù†",
    permissions: [
      { id: "sa_roles_1", value: "view", label: "View", labelAr: "Ø¹Ø±Ø¶", isEnabled: false },
      { id: "sa_roles_2", value: "add", label: "Add", labelAr: "Ø¥Ø¶Ø§ÙØ©", isEnabled: false },
      { id: "sa_roles_3", value: "update", label: "Update", labelAr: "ØªØ­Ø¯ÙŠØ«", isEnabled: false },
      { id: "sa_roles_4", value: "delete", label: "Delete", labelAr: "Ø­Ø°Ù", isEnabled: false },
    ],
  },
  {
    id: 103,
    title: "SA Users",
    titleAr: "Ù…Ø³ØªØ®Ø¯Ù…Ùˆ Ø§Ù„Ø³ÙˆØ¨Ø± Ø£Ø¯Ù…Ù†",
    permissions: [
      { id: "sa_users_1", value: "view", label: "View", labelAr: "Ø¹Ø±Ø¶", isEnabled: false },
      { id: "sa_users_2", value: "add", label: "Add", labelAr: "Ø¥Ø¶Ø§ÙØ©", isEnabled: false },
      { id: "sa_users_3", value: "update", label: "Update", labelAr: "ØªØ­Ø¯ÙŠØ«", isEnabled: false },
      { id: "sa_users_4", value: "delete", label: "Delete", labelAr: "Ø­Ø°Ù", isEnabled: false },
      {
        id: "sa_users_5",
        value: "restore",
        label: "View deleted users and Restore",
        labelAr: "Ø¹Ø±Ø¶ Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø§Ù„Ù…Ø­Ø°ÙˆÙÙŠÙ† ÙˆØ§Ø³ØªØ¹Ø§Ø¯ØªÙ‡Ù…",
        isEnabled: false,
      },
    ],
  },
  {
    id: 104,
    title: "SA Tenants",
    titleAr: "Ø§Ù„Ù…Ø³ØªØ£Ø¬Ø±ÙˆÙ†",
    permissions: [
      { id: "sa_tenants_1", value: "view", label: "View", labelAr: "Ø¹Ø±Ø¶", isEnabled: false },
      { id: "sa_tenants_2", value: "add", label: "Add", labelAr: "Ø¥Ø¶Ø§ÙØ©", isEnabled: false },
      { id: "sa_tenants_3", value: "update", label: "Update", labelAr: "ØªØ­Ø¯ÙŠØ«", isEnabled: false },
      {
        id: "sa_tenants_4",
        value: "login",
        label: "Login to tenant",
        labelAr: "Ø§Ù„Ø¯Ø®ÙˆÙ„ Ù„Ù„Ù…Ø³ØªØ£Ø¬Ø±",
        isEnabled: false,
      },
    ],
  },
  {
    id: 105,
    title: "SA Plans",
    titleAr: "Ø§Ù„Ø®Ø·Ø·",
    permissions: [
      { id: "sa_plans_1", value: "view", label: "View", labelAr: "Ø¹Ø±Ø¶", isEnabled: false },
      { id: "sa_plans_2", value: "add", label: "Add", labelAr: "Ø¥Ø¶Ø§ÙØ©", isEnabled: false },
      { id: "sa_plans_3", value: "update", label: "Update", labelAr: "ØªØ­Ø¯ÙŠØ«", isEnabled: false },
      { id: "sa_plans_4", value: "delete", label: "Delete", labelAr: "Ø­Ø°Ù", isEnabled: false },
    ],
  },
  {
    id: 106,
    title: "SA Billing",
    titleAr: "Ø§Ù„ÙÙˆØªØ±Ø©",
    permissions: [
      {
        id: "sa_billing_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
    ],
  },
  {
    id: 107,
    title: "SA Integrations",
    titleAr: "ØªÙƒØ§Ù…Ù„Ø§Øª Ø§Ù„Ù…Ù†ØµØ©",
    permissions: [
      {
        id: "sa_integrations_1",
        value: "view",
        label: "View Integrations",
        labelAr: "Ø¹Ø±Ø¶ Ø§Ù„ØªÙƒØ§Ù…Ù„Ø§Øª",
        isEnabled: false,
      },
      {
        id: "sa_integrations_2_add",
        value: "add_integration",
        label: "Add integration",
        labelAr: "Ø¥Ø¶Ø§ÙØ© ØªÙƒØ§Ù…Ù„",
        isEnabled: false,
      },
      {
        id: "sa_integrations_2_edit",
        value: "edit_integration",
        label: "Edit integration",
        labelAr: "ØªØ¹Ø¯ÙŠÙ„ ØªÙƒØ§Ù…Ù„",
        isEnabled: false,
      },
      {
        id: "sa_integrations_2_status",
        value: "integration_status",
        label: "Change integration status",
        labelAr: "ØªØºÙŠÙŠØ± Ø­Ø§Ù„Ø© Ø§Ù„ØªÙƒØ§Ù…Ù„",
        isEnabled: false,
      },
      {
        id: "sa_integrations_4_integration",
        value: "delete_integration",
        label: "Delete integration",
        labelAr: "Ø­Ø°Ù ØªÙƒØ§Ù…Ù„",
        isEnabled: false,
      },
      {
        id: "sa_integrations_3_add",
        value: "add_category",
        label: "Add category",
        labelAr: "Ø¥Ø¶Ø§ÙØ© ÙØ¦Ø©",
        isEnabled: false,
      },
      {
        id: "sa_integrations_3_edit",
        value: "edit_category",
        label: "Edit category",
        labelAr: "ØªØ¹Ø¯ÙŠÙ„ ÙØ¦Ø©",
        isEnabled: false,
      },
      {
        id: "sa_integrations_4_category",
        value: "delete_category",
        label: "Delete category",
        labelAr: "Ø­Ø°Ù ÙØ¦Ø©",
        isEnabled: false,
      },
      {
        id: "sa_integrations_5",
        value: "category_status",
        label: "Update Category status",
        labelAr: "ØªØ­Ø¯ÙŠØ« Ø­Ø§Ù„Ø© Ø§Ù„ÙØ¦Ø©",
        isEnabled: false,
      },
    ],
  },
  {
    id: 108,
    title: "SA Brands",
    titleAr: "Ø¹Ù„Ø§Ù…Ø§Øª Ø§Ù„Ù…Ù†ØµØ© Ø§Ù„ØªØ¬Ø§Ø±ÙŠØ©",
    permissions: [
      {
        id: "sa_brands_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "sa_brands_2",
        value: "add",
        label: "Add",
        labelAr: "Ø¥Ø¶Ø§ÙØ©",
        isEnabled: false,
      },
      {
        id: "sa_brands_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
      {
        id: "sa_brands_4",
        value: "delete",
        label: "Delete",
        labelAr: "Ø­Ø°Ù",
        isEnabled: false,
      },
    ],
  },
  {
    id: 109,
    title: "SA Website Builder",
    titleAr: "Ù…Ù†Ø´Ø¦ Ù…ÙˆØ§Ù‚Ø¹ Ø§Ù„Ø³ÙˆØ¨Ø± Ø£Ø¯Ù…Ù†",
    permissions: [
      {
        id: "sa_website_builder_1",
        value: "view",
        label: "View",
        labelAr: "Ø¹Ø±Ø¶",
        isEnabled: false,
      },
      {
        id: "sa_website_builder_3",
        value: "update",
        label: "Update",
        labelAr: "ØªØ­Ø¯ÙŠØ«",
        isEnabled: false,
      },
    ],
  },
]

export const ticketListsStatus = {
  1: "Pending",
  2: "Open",
  3: "In progress",
  4: "Resolved",
  5: "Closed",
  6: "Rejected",
}

export const statusListStatus = {
  1: {
    get text() {
      return i18next.t("Sent To Branch")
    },
    color: "#4A90E2",
  }, // Blue
  2: {
    get text() {
      return i18next.t("Start Preparing")
    },
    color: "#F5A623",
  }, // Orange
  3: {
    get text() {
      return i18next.t("Prepared")
    },
    color: "#ef0774",
  }, // Pink
  4: {
    get text() {
      return i18next.t("Collected")
    },
    color: "#50E3C2",
  }, // Teal
  5: {
    get text() {
      return i18next.t("Cancelled")
    },
    color: "#FF4D4F",
  }, // Red
  6: {
    get text() {
      return i18next.t("Sent To Branch Failed")
    },
    color: "#FF4D4F",
  }, // Red
}

/** Customer-facing statuses (mobile app) for brands without third-party POS. */
export const statusListMobileStatus = {
  1: {
    get text() {
      return i18next.t("Accepted")
    },
    color: "#4A90E2",
  },
  2: {
    get text() {
      return i18next.t("Preparing")
    },
    color: "#F5A623",
  },
  3: {
    get text() {
      return i18next.t("Ready for Pickup")
    },
    color: "#ef0774",
  },
  4: {
    get text() {
      return i18next.t("Delivered")
    },
    color: "#50E3C2",
  },
  5: {
    get text() {
      return i18next.t("Cancelled")
    },
    color: "#FF4D4F",
  },
}

export const statusListSalasaStatus = {
  1: {
    get text() {
      return i18next.t("Confirmed")
    },
    color: "#4A90E2",
  }, // Blue
  2: {
    get text() {
      return i18next.t("Backorder")
    },
    color: "#F5A623",
  }, // Orange
  3: {
    get text() {
      return i18next.t("Hold")
    },
    color: "#ef0774",
  }, // Pink
  4: {
    get text() {
      return i18next.t("Processing")
    },
    color: "#50E3C2",
  }, // Teal
  5: {
    get text() {
      return i18next.t("Shipped")
    },
    color: "#FF4D4F",
  }, // Red
  6: {
    get text() {
      return i18next.t("In Transit")
    },
    color: "#FF4D4F",
  }, // Red
  7: {
    get text() {
      return i18next.t("Delivered")
    },
    color: "#4fff4d",
  }, // Green
  8: {
    get text() {
      return i18next.t("Cancelled")
    },
    color: "#FF4D4F",
  }, // Red
}

export const bookingStatus = {
  1: "Pending",
  2: "Open",
  3: "Confirmed",
  4: "Completed",
  5: "Cancelled",
  6: "Rejected",
}
export const orderStatus = {
  1: "Sent To Branch",
  2: "Start Preparing",
  3: "Prepared",
  4: "Collected",
  5: "Cancelled",
}

/** Update-status options for brands without third-party POS (mobile terminology). */
export const mobileOrderStatus = {
  1: "Accepted",
  2: "Preparing",
  3: "Ready for Pickup",
  4: "Picked Up",
  5: "Cancelled",
}

export const salasaOrderStatus = {
  // 0: "Pending",
  // 1: "Created",
  // 2: "Backorder",
  // 3: "Hold",
  // 4: "Processing",
  // 5: "Shipped",
  // 6: "In Transit",
  // 7: "Delivered",
  // 8: "Cancelled",
  // 8: "Cancel",
  8: "Cancelled By Platform",
}

// (for payment-methods) reports
export const groupByForPaymentMethods = [
  {
    label: "None",
    value: "",
  },
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "Order Type",
    value: "orderType",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Hour",
    value: "hour",
  },
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "Quarter",
    value: "quarter",
  },
  {
    label: "Half",
    value: "half",
  },
  {
    label: "Day Of Month",
    value: "dayOfMonth",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Day Of Year",
    value: "dayOfYear",
  },
  {
    label: "Day Of Week",
    value: "dayOfWeek",
  },
]

export const paymentMethodTypes = [
  // {
  //   label: "Cash On Delivery",
  //   value: "COD",
  // },
  {
    label: "Card",
    value: "CARD",
  },
  {
    label: "Card On Delivery",
    value: "CARD_ON_DELIVERY",
  },
  {
    label: "Apple Pay",
    value: "APPLE",
  },
  {
    label: "Mokafaa Points",
    value: "ALRAJHI_BANK",
  },
  {
    label: "Loyalty Points",
    value: "LOYALTY_REWARDS",
  },
  // {
  //   label: "Checkout",
  //   value: "CHECKOUT",
  // },
  // {
  //   label: "Full Discount or Rewards",
  //   value: "FULL_DISCOUNT_OR_REWARDS",
  // },
  {
    label: "Full Discount",
    value: "FULL_DISCOUNT",
  },
  {
    label: "Partial-Card/Apple",
    value: "Partial-Card/Apple",
  },
  {
    label: "Partial-Wallet",
    value: "Partial-Wallet",
  },
  {
    label: "Partial-Reward",
    value: "Partial-Reward",
  },
  {
    label: "Partial-Discount",
    value: "Partial-Discount",
  },
]

export const apexBarChartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: true,
  },

  colors: ["#34c38f"],
  grid: {
    borderColor: "#f1f1f1",
  },
  xaxis: {},
}

export const groupByBusinessTaxReport = [
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "Order",
    value: "order",
  },
]

export const salesByForSales = [
  {
    label: "Branch",
    value: "branch",
    colName: "branchName",
    colNameAr: "branchNameAr",
  },
  {
    label: "Category",
    value: "category",
    colName: "categoryName",
    colNameAr: "categoryNameAr",
  },
  {
    label: "Item",
    value: "item",
    colName: "itemName",
    colNameAr: "itemNameAr",
  },
  {
    label: "Modifier",
    value: "modifier",
    colName: "modifierName",
    colNameAr: "modifierNameAr",
  },
  {
    label: "Order Type",
    value: "orderType",
    colName: "orderType",
    colNameAr: "orderType",
  },
  {
    label: "Customer",
    value: "customer",
    colName: "customerName",
    colNameAr: "customerName",
  },
  {
    label: "Coupon",
    value: "coupon",
    colName: "couponName",
    colNameAr: "couponNameAr",
  },
  {
    label: "Platform",
    value: "platform",
    colName: "platform",
    colNameAr: "platform",
  },
  {
    label: "Payment Method",
    value: "paymentMethod",
    colName: "",
    colNameAr: "",
  },
  {
    label: "Customer",
    value: "customer",
    colName: "paymentMethod",
    colNameAr: "paymentMethod",
  },
  {
    label: "Discount",
    value: "promotion",
    colName: "promotionName",
    colNameAr: "promotionName",
  },
  {
    label: "City",
    value: "city",
    colName: "cityName",
    colNameAr: "cityNameAr",
  },
  {
    label: "Region",
    value: "region",
    colName: "regionName",
    colNameAr: "regionNameAr",
  },
  {
    label: "Country",
    value: "country",
    colName: "countryName",
    colNameAr: "countryNameAr",
  },
]

export const b2csalesByForSales = [
  {
    label: "Category",
    value: "category",
    colName: "categoryName",
    colNameAr: "categoryNameAr",
  },
  {
    label: "Item",
    value: "item",
    colName: "itemName",
    colNameAr: "itemNameAr",
  },
  {
    label: "Modifier",
    value: "modifier",
    colName: "modifierName",
    colNameAr: "modifierNameAr",
  },
  {
    label: "Order Type",
    value: "orderType",
    colName: "orderType",
    colNameAr: "orderType",
  },
  {
    label: "Customer",
    value: "customer",
    colName: "customerName",
    colNameAr: "customerName",
  },
  {
    label: "Coupon",
    value: "coupon",
    colName: "couponName",
    colNameAr: "couponNameAr",
  },
  {
    label: "Platform",
    value: "platform",
    colName: "platform",
    colNameAr: "platform",
  },
  {
    label: "Payment Method",
    value: "paymentMethod",
    colName: "",
    colNameAr: "",
  },
  {
    label: "Customer",
    value: "customer",
    colName: "paymentMethod",
    colNameAr: "paymentMethod",
  },
  {
    label: "Discount",
    value: "promotion",
    colName: "promotionName",
    colNameAr: "promotionName",
  },
  {
    label: "City",
    value: "city",
    colName: "cityName",
    colNameAr: "cityNameAr",
  },
  {
    label: "Region",
    value: "region",
    colName: "regionName",
    colNameAr: "regionNameAr",
  },
  {
    label: "Country",
    value: "country",
    colName: "countryName",
    colNameAr: "countryNameAr",
  },
]

export const groupByForSales = [
  {
    label: "None",
    value: "",
  },
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "Category",
    value: "category",
  },
  {
    label: "Item",
    value: "item",
  },
  {
    label: "Modifier",
    value: "modifier",
  },
  {
    label: "Order Type",
    value: "orderType",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Coupon",
    value: "coupon",
  },
  {
    label: "Platform",
    value: "platform",
  },
  {
    label: "Payment Method",
    value: "paymentMethod",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Discount",
    value: "promotion",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "Region",
    value: "region",
  },
  {
    label: "Country",
    value: "country",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Hour",
    value: "hour",
  },
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "Quarter",
    value: "quarter",
  },
  {
    label: "Half",
    value: "half",
  },
  {
    label: "Day Of Month",
    value: "dayOfMonth",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Day Of Year",
    value: "dayOfYear",
  },
  {
    label: "Day Of Week",
    value: "dayOfWeek",
  },
]
export const b2cgroupByForSales = [
  {
    label: "None",
    value: "",
  },

  {
    label: "Category",
    value: "category",
  },
  {
    label: "Item",
    value: "item",
  },
  {
    label: "Modifier",
    value: "modifier",
  },
  {
    label: "Order Type",
    value: "orderType",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Coupon",
    value: "coupon",
  },
  {
    label: "Platform",
    value: "platform",
  },
  {
    label: "Payment Method",
    value: "paymentMethod",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Discount",
    value: "promotion",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "Region",
    value: "region",
  },
  {
    label: "Country",
    value: "country",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Hour",
    value: "hour",
  },
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "Quarter",
    value: "quarter",
  },
  {
    label: "Half",
    value: "half",
  },
  {
    label: "Day Of Month",
    value: "dayOfMonth",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Day Of Year",
    value: "dayOfYear",
  },
  {
    label: "Day Of Week",
    value: "dayOfWeek",
  },
]

export const groupByForLoyaltyPoints = [
  {
    label: "Order",
    value: "order",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Branch",
    value: "branch",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "Region",
    value: "region",
  },
  {
    label: "Country",
    value: "country",
  },
]

export const branchSettingOptions = [
  { label: "Opening Hours", labelAr: "Ø³Ø§Ø¹Ø§Øª Ø§Ù„Ø¹Ù…Ù„", value: "openingHours" },
  { label: "City", labelAr: "Ù…Ø¯ÙŠÙ†Ø©", value: "cityId" },
  { label: "Users", labelAr: "Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙˆÙ†", value: "users" },
  { label: "Discount", labelAr: "ØªØ®ÙÙŠØ¶", value: "discount" },
]

export const allOption = {
  get label() {
    return i18next.t("Select All")
  },
  value: "*",
}

export const disablePastDates = date => {
  const today = new Date()
  today.setHours(0, 0, 0, 0) // Reset time to midnight to compare only the date
  return date < today // Disable all dates before today
}

const isSameCalendarDay = (left, right) =>
  left.getFullYear() === right.getFullYear() &&
  left.getMonth() === right.getMonth() &&
  left.getDate() === right.getDate()

/** Block past calendar days, and past hours/minutes when the selected day is today. */
export const disablePastDateTime = {
  shouldDisableDate(date) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return date < today
  },
  shouldDisableHour(hour, date) {
    if (!date) return false
    const now = new Date()
    if (!isSameCalendarDay(date, now)) return false
    return hour < now.getHours()
  },
  shouldDisableMinute(minute, date) {
    if (!date) return false
    const now = new Date()
    if (!isSameCalendarDay(date, now)) return false
    if (date.getHours() > now.getHours()) return false
    if (date.getHours() < now.getHours()) return true
    return minute <= now.getMinutes()
  },
}

export const timesUTC = [
  "12 AM",
  "1 AM",
  "2 AM",
  "3 AM",
  "4 AM",
  "5 AM",
  "6 AM",
  "7 AM",
  "8 AM",
  "9 AM",
  "10 AM",
  "11 AM",
  "12 PM",
  "1 PM",
  "2 PM",
  "3 PM",
  "4 PM",
  "5 PM",
  "6 PM",
  "7 PM",
  "8 PM",
  "9 PM",
  "10 PM",
  "11 PM",
]

export const selectedTimes = [
  {
    dayOfWeek: "Sunday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Monday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Tuesday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Wednesday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Thursday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Friday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
  {
    dayOfWeek: "Saturday",
    openingTime: "00:00",
    closingTime: "23:59",
    closed: false,
  },
]

export const getPerPageOptions = (totalCount, currentPerPage) => {
  let options
  if (totalCount <= 20) options = [10]
  else if (totalCount <= 50) options = [10, 20]
  else if (totalCount <= 100) options = [10, 20, 50]
  else options = [10, 20, 50, 100]

  const current = Number(currentPerPage)
  if (current > 0 && !options.includes(current)) {
    options = [...options, current].sort((a, b) => a - b)
  }
  return options
}

export const editorModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // Adds headings: h1, h2, h3, normal text
    ["bold", "italic", "underline"], // Formatting buttons
    [{ list: "ordered" }, { list: "bullet" }], // Lists
    ["link", "image"], // Add links and images
    [{ align: [] }], // Text alignment
    ["clean"], // Remove formatting button
  ],
}

export const editorFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
  "image",
  "align",
  "direction",
]

export const todayDate = format(new Date(), "yyyy-MM-dd")
export const todayStartDate = format(new Date(), "yyyy-MM-dd") + " 00:00"
export const todayEndDate = format(new Date(), "yyyy-MM-dd") + " 23:59"

export const giftCardStatus = [
  {
    label: "Order",
    value: "order",
  },
]

export const giftCardTypes = {
  name: "type",
  type: "select",
  get options() {
    return [
      { label: i18next.t("All"), value: 0 },
      { label: i18next.t("Live"), value: 1 },
      { label: i18next.t("Upcoming"), value: 2 },
      { label: i18next.t("Expired"), value: 3 },
    ]
  },
  get placeholder() {
    return i18next.t("All")
  },
}

export const cardCategories = categories => {
  const categoryOptions =
    categories?.map(category => ({
      value: category._id,
      label: category.cardType,
    })) || []

  return {
    name: "cardType",
    type: "select",
    get options() {
      return [...categoryOptions, { label: i18next.t("All"), value: null }]
    },
    get placeholder() {
      return i18next.t("All")
    },
  }
}

export const dataTypes = [
  { label: "TEXT", value: "text" },
  { label: "NUMBER", value: "number" },
  { label: "BOOLEAN", value: "boolean" },
  { label: "FLOAT", value: "fLoat" },
]
